import { render, staticRenderFns } from "./veStuFileEdit.vue?vue&type=template&id=6cb48a8c&scoped=true"
import script from "./veStuFileEdit.vue?vue&type=script&lang=js"
export * from "./veStuFileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb48a8c",
  null
  
)

export default component.exports